module.exports = "/build/web/svg/sold_out.5b8d40130b4f06923adab5b22a0d874d.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/sold_out.svg
// module id = 205
// module chunks = 24